<template>
  <div class="popular_courses">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="section_title text-center mb-100">
            <h3>热门课程</h3>
            <p>
              以数据、算法、网络、信息处理、信息安全、人工智能为课程逻辑主线
              <br />
              按照义务教育阶段学生的认知发展规律，设计各学段学习内容.
            </p>
          </div>
        </div>
      </div>
      <div class="row" v-if="showThemes">
        <div class="col-xl-12">
          <div class="course_nav">
            <nav>
              <ul class="nav" id="myTab" role="tablist">
                <li class="nav-item">
                  <a
                    :class="
                      -1 == modelRef.isHover ? 'nav-link active' : 'nav-link'
                    "
                    id="home-tab"
                    data-toggle="tab"
                    role="tab"
                    aria-controls="home"
                    aria-selected="true"
                    @click.prevent="courseThemeChange(null, -1)"
                    >所有课程</a
                  >
                </li>
                <li
                  v-for="(courseTheme, index) in modelRef.courseThemes"
                  :key="index"
                  class="nav-item"
                  @click.prevent="courseThemeChange(courseTheme.id, index)"
                >
                  <a
                    :class="
                      index == modelRef.isHover ? 'nav-link active' : 'nav-link'
                    "
                    id="profile-tab"
                    data-toggle="tab"
                    href="#profile"
                    role="tab"
                    aria-controls="profile"
                    aria-selected="false"
                    >{{ courseTheme.courseTheme }}</a
                  >
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="all_courses">
      <div class="container">
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <div class="row">
              <template v-if="modelRef.courseList.length > 0">
                <div
                  @click.prevent="goDetail(course.courseId)"
                  class="col-xl-4 col-lg-4 col-md-6"
                  :key="key"
                  v-for="(course, key) in modelRef.courseList"
                >
                  <div class="single_courses" style="cursor: pointer">
                    <div class="thumb">
                      <a href="#">
                        <img :src="course.coverUrl" alt="" />
                      </a>
                    </div>
                    <div class="courses_info">
                      <span>{{ course.courseName }}</span>
                      <h3 class="course_description">
                        <a href="#">{{ course.courseDescription }} <br /> </a>
                      </h3>
                      <div class="star_prise d-flex justify-content-between">
                        <div>
                          <a-rate
                            v-model:value="modelRef.score"
                            :count="1"
                            :disabled="true"
                          />
                          <span>({{ course.score }})</span>
                        </div>
                        <div class="prise">
                          <span class="offer"
                            >¥{{ (course.coursePrice * 1.5) / 100 }}</span
                          >
                          <span class="active_prise">
                            ¥{{ course.coursePrice / 100 }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div class="default-box" v-if="!modelRef.courseList.length > 0">
                <img src="@/assets/images/default_Icon.png" />
                <p>板块紧张制作中……</p>
              </div>
              <div class="col-xl-12">
                <div class="more_courses text-center" v-if="!showThemes">
                  <a
                    href="#"
                    @click.prevent="goLink('/courseShop')"
                    class="boxed_btn_rev"
                    >更多课程</a
                  >
                </div>
                <div class="more_courses text-center" v-if="showThemes">
                  <a-pagination
                    v-model:current="modelRef.pageNum"
                    :total="modelRef.total"
                    :defaultPageSize="modelRef.pageSize"
                    show-less-items
                    :hideOnSinglePage="true"
                    @change="getCourses"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive } from "vue";
import { useRouter } from "vue-router";
import { getCourseTypeAndTheme, getCourseList } from "@/apis/ow.js";

export default defineComponent({
  props: { showTheme: Boolean },
  setup(props) {
    const router = useRouter();
    const modelRef = reactive({
      courseThemes: {},
      courseList: {},
      isHover: -1,
      pageSize: 6,
      total: 0,
      pageNum: 1,
      courseThemeId: null,
      score: 1,
    });

    // 获取课程主题
    getCourseTypeAndTheme().then((res) => {
      if (res.code === 200) {
        modelRef.courseThemes = res.data.courseThemes;
      }
    });

    // 获取课程
    const getCourses = (pageNum, pageSize) => {
      const params = {
        pageNum,
        pageSize,
        courseThemeId: modelRef.courseThemeId,
      };
      getCourseList(params).then((res) => {
        if (res.code === 200) {
          modelRef.pageNum = pageNum;
          modelRef.total = res.total;
          modelRef.courseList = res.rows;
        }
      });
    };

    // 编程语言字典
    const codingLanguageArr = ["无需编程", "Scratch", "Python", "C++"];

    // 初始化课程列表
    getCourses(1, 6);

    // 课程主题变更
    const courseThemeChange = (courseThemeId, index) => {
      modelRef.isHover = index;
      modelRef.courseThemeId = courseThemeId;
      getCourses(1, 6);
    };

    // 跳转详情页面
    const goDetail = (courseId) => {
      router.push("courseDetail/" + courseId);
    };

    // 跳转链接
    const goLink = (link) => {
      router.push(link);
    };

    return {
      showThemes: props.showTheme,
      modelRef,
      goDetail,
      courseThemeChange,
      codingLanguageArr,
      getCourses,
      goLink,
    };
  },
});
</script>

<style>
.course_description {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.star_prise .ant-rate .anticon-star {
  color: #fadb14 !important;
}

.default-box {
  text-align: center;
  width: 100%;
  padding-top: 50px;
}

.default-box img {
  width: 510px;
  height: 280px;
}

.default-box p {
  padding-top: 30px;
  font-size: 16px;
  color: #010101;
}
</style>
